import { Fragment } from "react";
import {configsAccivalProd} from './configsAccival';


export function AcciValPage({payload}) {

    return (
        <Fragment>
            <form method="post" target="_blank" action={configsAccivalProd.urlAction}>
                <input name="merchant_id" type="hidden"  value={configsAccivalProd.merchantId} />
                <input name="form_id" type="hidden"  value={configsAccivalProd.formId} />
                <input name="terminal_id" type="hidden"  value={configsAccivalProd.terminalId} />
                <input name="order_number" type="hidden"  value={payload?.orderNumber} />
                <input name="amount" type="hidden"  value={payload?.amount} />
                <input name="currency" type="hidden"  value={configsAccivalProd.currency} />
                <input name="order_description" type="hidden"  value={payload?.orderDescription} />
                <input name="color_base" type="hidden"  value={configsAccivalProd.colorBase} />
                <input name="client_email" type="hidden" value={payload?.email} />
                <input name="client_phone" type="hidden" value={payload?.phone} />
                <input name="client_firstname" type="hidden" value={payload?.firstname} />
                <input name="client_lastname" type="hidden" value={payload?.lastname}/>
                <input name="client_doctype" type="hidden" value={payload?.doctype} />
                <input name="client_numdoc" type="hidden" value={payload?.documento} />
                <input name="response_url" type="hidden" value={configsAccivalProd.responseUrl} />
                <input name="aditional_data" type="hidden" value={payload.additionalData} />
                <input name="Submit" type="submit" style={{color: "#2b253d", background: "#29d884", padding: "8px 8px", border: 'none', cursor: 'pointer', borderRadius: '5px', fontSize: '0.875rem'}}  value="Pagar ahora >" />
            </form>
        </Fragment>
    )

}